/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCreditLineOfferSelectedDecision_selectedDecision_Decision = { readonly __typename: 'Decision', readonly id: string, readonly salesforceCreditId: string | null };

export type UpdateCreditLineOfferSelectedDecision_Mutation = { readonly __typename: 'Mutation', readonly selectedDecision: UpdateCreditLineOfferSelectedDecision_selectedDecision_Decision | null };


export type UpdateCreditLineOfferSelectedDecisionVariables = _Types.Exact<{
  id: _Types.Scalars['String']['input'];
  salesforceCreditId: _Types.Scalars['String']['input'];
  selectedAmount?: _Types.InputMaybe<_Types.Scalars['Int']['input']>;
}>;


export type UpdateCreditLineOfferSelectedDecision = UpdateCreditLineOfferSelectedDecision_Mutation;


export const UpdateCreditLineOfferSelectedDecisionDocument = gql`
    mutation UpdateCreditLineOfferSelectedDecision($id: String!, $salesforceCreditId: String!, $selectedAmount: Int) {
  selectedDecision(
    id: $id
    salesforceCreditId: $salesforceCreditId
    selectedAmount: $selectedAmount
  ) {
    id
    salesforceCreditId
  }
}
    `;
export type UpdateCreditLineOfferSelectedDecisionMutationFn = Apollo.MutationFunction<UpdateCreditLineOfferSelectedDecision, UpdateCreditLineOfferSelectedDecisionVariables>;

/**
 * __useUpdateCreditLineOfferSelectedDecision__
 *
 * To run a mutation, you first call `useUpdateCreditLineOfferSelectedDecision` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditLineOfferSelectedDecision` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditLineOfferSelectedDecision, { data, loading, error }] = useUpdateCreditLineOfferSelectedDecision({
 *   variables: {
 *      id: // value for 'id'
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      selectedAmount: // value for 'selectedAmount'
 *   },
 * });
 */
export function useUpdateCreditLineOfferSelectedDecision(baseOptions?: Apollo.MutationHookOptions<UpdateCreditLineOfferSelectedDecision, UpdateCreditLineOfferSelectedDecisionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditLineOfferSelectedDecision, UpdateCreditLineOfferSelectedDecisionVariables>(UpdateCreditLineOfferSelectedDecisionDocument, options);
      }
export type UpdateCreditLineOfferSelectedDecisionHookResult = ReturnType<typeof useUpdateCreditLineOfferSelectedDecision>;
export type UpdateCreditLineOfferSelectedDecisionMutationResult = Apollo.MutationResult<UpdateCreditLineOfferSelectedDecision>;
export type UpdateCreditLineOfferSelectedDecisionMutationOptions = Apollo.BaseMutationOptions<UpdateCreditLineOfferSelectedDecision, UpdateCreditLineOfferSelectedDecisionVariables>;